import React, {useMemo, useState} from 'react';
import Loader from '../components/Loader';
import './AddressForm.css';


const empty = {
  full_name: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  postal_code: '',
  country: '',
  phone: '',
  is_default: false,
};

const AddressForm = ({ initialValues = {}, onSubmit, onCancel }) => {
    const init = useMemo(() => ({ ...empty, ...initialValues }), [initialValues]);
    const [values, setValues] = useState(init);
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const set = (k) => (e) =>
        setValues((v) => ({
            ...v,
            [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
        }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const trimmed = {
            full_name: values.full_name.trim(),
            line1: values.line1.trim(),
            line2: values.line2.trim(),
            city: values.city.trim(),
            state: values.state.trim(),
            postal_code: values.postal_code.trim(),
            country: values.country.trim(),
            phone: values.phone.trim(),
            is_default: Boolean(values.is_default),
        };

        if (!trimmed.full_name || !trimmed.line1 || !trimmed.city || !trimmed.country || !trimmed.postal_code) {
            setError('Please fill required fields: Full name, Address line 1, City, Postal code, Country.');
            return;
        }

        setSubmitting(true);
        try {
            if (onSubmit) {
                await onSubmit(trimmed);
            }
        } catch (err) {
            setError(err.message || 'Failed to save address.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="address-form">
            {error && <div className="address-form__error">{error}</div>}

            <label className="address-form__field">
                <span className="address-form__label">Full name*</span>
                <input className="address-form__input" value={values.full_name} onChange={set('full_name')} placeholder="Jane Doe" />
            </label>

            <label className="address-form__field">
                <span className="address-form__label">Address line 1*</span>
                <input className="address-form__input" value={values.line1} onChange={set('line1')} placeholder="123 Main St" />
            </label>

            <label className="address-form__field">
                <span className="address-form__label">Address line 2</span>
                <input className="address-form__input" value={values.line2} onChange={set('line2')} placeholder="Apt, suite, etc." />
            </label>

            <div className="address-form__row">
                <label className="address-form__field">
                    <span className="address-form__label">City*</span>
                    <input className="address-form__input" value={values.city} onChange={set('city')} placeholder="City" />
                </label>
                <label className="address-form__field">
                    <span className="address-form__label">State/Region</span>
                    <input className="address-form__input" value={values.state} onChange={set('state')} placeholder="State/Region" />
                </label>
            </div>

            <div className="address-form__row">
                <label className="address-form__field">
                    <span className="address-form__label">Postal code*</span>
                    <input className="address-form__input" value={values.postal_code} onChange={set('postal_code')} placeholder="ZIP/Postal" />
                </label>
            </div>

            <label className="address-form__field">
                <span className="address-form__label">Country*</span>
                <input className="address-form__input" value={values.country} onChange={set('country')} placeholder="Country" />
            </label>

            <label className="address-form__field">
                <span className="address-form__label">Phone</span>
                <input className="address-form__input" value={values.phone} onChange={set('phone')} placeholder="Optional" />
            </label>

            <label className="address-form__checkbox">
                <input type="checkbox" checked={values.is_default} onChange={set('is_default')} />
                <span>Set as default</span>
            </label>

            <div className="address-form__actions">
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                    {submitting ? <Loader size="small" color="#fff" /> : (initialValues?.id ? 'Update' : 'Save address')}
                </button>
                <button type="button" className="btn" onClick={onCancel} disabled={submitting}>Cancel</button>
            </div>
        </form>
    );

}


export default AddressForm;
